var _defs, _rect, _rect2, _rect3, _g, _g2, _g3, _g4, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "academicPattern",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20 L40,20 M20,0 L20,40",
    stroke: "#E3F2FD",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 2,
    fill: "#BBDEFB"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "#1565C0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "url(#academicPattern)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 780,
    height: 180,
    rx: 5,
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -10,
    width: 40,
    height: 8,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,-10 C20,-20 25,-25 30,-22",
    stroke: "#FFC107",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: -22,
    r: 4,
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L-25,-20 L0,-40 L25,-20 L0,0 Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -20,
    r: 5,
    fill: "#FFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -15,
    width: 60,
    height: 10,
    rx: 1,
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: -5,
    width: 60,
    height: 10,
    rx: 1,
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -38,
    y: 5,
    width: 60,
    height: 10,
    rx: 1,
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: 15,
    width: 60,
    height: 10,
    rx: 1,
    fill: "#9C27B0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -15,
    width: 5,
    height: 10,
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: -5,
    width: 5,
    height: 10,
    fill: "#388E3C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -38,
    y: 5,
    width: 5,
    height: 10,
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: 15,
    width: 5,
    height: 10,
    fill: "#7B1FA2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 45) rotate(30)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -5,
    width: 80,
    height: 10,
    rx: 2,
    fill: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40,-5 50,0 40,5",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -5,
    width: 10,
    height: 10,
    rx: 2,
    fill: "#EC407A"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -40,
    y1: -5,
    x2: -40,
    y2: 5,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -5,
    x2: 0,
    y2: 5,
    stroke: "#FFA000",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -20,
    width: 200,
    height: 30,
    rx: 2,
    fill: "#FFF",
    stroke: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -90,
    y1: -10,
    x2: -40,
    y2: -10,
    stroke: "#616161",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -35,
    cy: -10,
    r: 2,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -30,
    y1: -10,
    x2: 0,
    y2: -10,
    stroke: "#616161",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -90,
    y1: 0,
    x2: -70,
    y2: 0,
    stroke: "#616161",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -65,
    cy: 0,
    r: 2,
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60,
    y1: 0,
    x2: -20,
    y2: 0,
    stroke: "#616161",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: -10,
    x2: 90,
    y2: -10,
    stroke: "#616161",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 0,
    x2: 80,
    y2: 0,
    stroke: "#616161",
    strokeWidth: 1
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 80,
    fontFamily: "Arial, sans-serif",
    fontSize: 35,
    fontWeight: "bold",
    fill: "#FFF",
    textAnchor: "middle"
  }, "STUDENT DISCOUNT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 120,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#FFECB3",
    textAnchor: "middle"
  }, "10% OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 150,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#FFF",
    textAnchor: "middle"
  }, "For all students with valid ID")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentDiscount);
export default __webpack_public_path__ + "static/media/student_discount.0ae9168f8ecce44caeb0283dab503045.svg";
export { ForwardRef as ReactComponent };